// import React, { useState } from 'react'
// import chatBg from '../images/bg-pattern-liveAgent.png'

// import SenderIcon from '../images/callericon.png'
// import { LuSquareArrowOutUpRight } from "react-icons/lu";
// import { FaArtstation } from "react-icons/fa";
// import { MdBlock } from "react-icons/md";
// import { IoIosArrowDown } from "react-icons/io";
// import { IoIosArrowUp } from "react-icons/io";
// import { MdAdd } from "react-icons/md";
// import { FaUser } from "react-icons/fa";
// import { FaEdit } from "react-icons/fa";
// import { MdDelete } from "react-icons/md";

// import AddNotesModal from './Addnotes';

// // Helper: Try to infer display name as fallback
// function getProfileName(user) {
//     return user?.ProfileName || user?.name || user?.from_number || "";
// }
// function getWANumber(user) {
//     return user?.WANumber || user?.from_number || "";
// }

// function WhatappchatforArchive({ selectedUser }) {
//     // Normalize available chat/message structure:
//     // Support legacy structure: selectedUser.Chats
//     // New API structure: selectedUser.messages (and others)
//     const chatsArray = Array.isArray(selectedUser?.Chats)
//         ? selectedUser.Chats
//         : (
//             Array.isArray(selectedUser?.messages)
//                 ? selectedUser.messages.map(msg => ({
//                     // Map new structure to common structure expected by code:
//                     ReceivedDate: msg.created_at,
//                     MessageText: msg.content,
//                     ChatType: msg.status === 'received' ? 'IN' : 'OUT',
//                     ...msg
//                 }))
//                 : []
//         );

//     // Defensive: profile and numbers
//     const safeProfileName = getProfileName(selectedUser);
//     const safeWANumber = getWANumber(selectedUser);

//     // Last message and time
//     const lastMessage = chatsArray.length > 0 ? chatsArray[chatsArray.length - 1] : undefined;
//     const lastTime = lastMessage?.ReceivedDate || selectedUser?.lastTime || selectedUser?.last_message_time || "";

//     const [AssignAgent, setAssignAgent] = useState(false)
//     const [Notes, setNotes] = useState(false)
//     const [Customer, setCustomer] = useState(false)
//     const [Notestext, setNotestext] = useState('')

//     const [AddNotes, setAddNotes] = useState([]);
//     const [open, setOpen] = useState(false);
//     const [time, setTime] = useState('');
//     const [updateNote, setupdateNote] = useState('')

//     // First message details
//     const firstMessage = chatsArray.length > 0 ? chatsArray[0] : undefined;
//     const firstTime = firstMessage?.ReceivedDate;
//     const FirstDate = firstMessage?.TimePassed || "";

//     // Defensive: Fallback for last user message or archive
//     const safeLastUserMessage = selectedUser?.LastUserMessage
//         || selectedUser?.lastMessage
//         || (
//             lastMessage?.MessageText
//                 || lastMessage?.content
//                 || ""
//         );

//     const safeTimePassed = selectedUser?.TimePassed || "";

//     function formatDateLabel(date) {
//         if (!date) return '';
//         const d = new Date(date);
//         const today = new Date();
//         const yesterday = new Date();
//         yesterday.setDate(today.getDate() - 1);

//         if (d.toDateString() === today.toDateString()) {
//             return "Today";
//         }

//         if (d.toDateString() === yesterday.toDateString()) {
//             return "Yesterday";
//         }

//         return d.toLocaleDateString("en-GB", {
//             day: "2-digit",
//             month: "short",
//             year: "numeric",
//         });
//     }

//     const formatTime = (date) => {
//         if (!date) return '';
//         return new Date(date).toLocaleTimeString([], {
//             hour: "2-digit",
//             minute: "2-digit",
//         });
//     };

//     function getTime() {
//         const now = new Date();

//         let day = String(now.getDate()).padStart(2, '0');
//         let month = String(now.getMonth() + 1).padStart(2, '0');
//         let year = now.getFullYear();

//         let hours = now.getHours();
//         let minutes = String(now.getMinutes()).padStart(2, '0');

//         let ampm = hours >= 12 ? 'PM' : 'AM';
//         hours = hours % 12 || 12;

//         return `${month}/${day}/${year} ${String(hours).padStart(2, '0')}:${minutes}${ampm}`;
//     }

//     const [editId, seteditId] = useState(null)

//     function addNotes() {
//         if (!Notestext.trim()) return;

//         if (editId) {
//             setAddNotes((prev) =>
//                 prev.map((item) =>
//                     item.id === editId
//                         ? { ...item, text: Notestext }
//                         : item
//                 )
//             );
//             seteditId(null);
//         } else {
//             const newNote = {
//                 id: AddNotes.length + 1,
//                 text: Notestext,
//                 time: getTime()
//             };
//             setAddNotes((prev) => [...prev, newNote]);
//         }

//         setNotestext('');
//         setOpen(false);
//     }

//     const deleteNote = (id) => {
//         const updatedNotes = AddNotes.filter((item) => item.id !== id);
//         setAddNotes(updatedNotes);
//     }

//     return (
//         <>
//             <div className='w-[100%] flex h-auto '>
//                 <div
//                     style={{ backgroundImage: `url(${chatBg})` }}
//                     className='w-[60%] bg-cover bg-center h-[500px]'>
//                     <div className='w-[100%] border-[#e3e9ef] border-b-[1px] py-2 px-4 flex gap-4'>
//                         <div className='w-[60px] h-[60px] bg-[#0000000d] rounded-full flex justify-center items-center text-[28px] uppercase font-semibold text-[#576071] '>
//                             {(safeProfileName).slice(0, 2)}
//                         </div>
//                         <div>
//                             <h3 className='text-[#000] text-[16px] font-bold capitalize'>{safeProfileName}</h3>
//                             <h3 className='text-[#858c97] text-[16px] font-bold capitalize'>{safeWANumber}</h3>
//                         </div>
//                     </div>
//                     <div className='h-[480px] overflow-y-auto'>
//                         {chatsArray.length > 0 ? (
//                             chatsArray.map((chat, index) => {
//                                 const currentDate = new Date(chat.ReceivedDate).toDateString();
//                                 const prevDate =
//                                     index > 0
//                                         ? new Date(chatsArray[index - 1].ReceivedDate).toDateString()
//                                         : null;
//                                 const showDate = currentDate !== prevDate;
//                                 return (
//                                     <div className='w-[100%] px-2 ' key={(chat?.id || chat?.ReceivedDate || index)}>
//                                         {showDate && (
//                                             <div className="text-center my-3 w-[100%]">
//                                                 <span className="bg-gray-200 text-xs px-3 py-1 rounded-full font-bold text-[#434a57]">
//                                                     {formatDateLabel(chat.ReceivedDate)}
//                                                 </span>
//                                             </div>
//                                         )}
//                                         <div className={` w-[100%]`}>
//                                             <div className=''>
//                                                 {chat.ChatType === 'IN' ?
//                                                     <div className={`flex gap-2 justify-start flex`}>
//                                                         <div className='w-[48px] h-[48px] bg-[#3f7fca26] rounded-full flex justify-center items-center text-[20px] uppercase font-semibold text-[#3f7fca] '>
//                                                             {(safeProfileName).slice(0, 2)}
//                                                         </div>
//                                                         <div>
//                                                             <div className='bg-[#3f80ca15] p-4  text-[13px] font-semibold text-[#121519d1] rounded-t-[20px] rounded-r-[20px] rounded-bl-none'>
//                                                                 {chat.MessageText}
//                                                             </div>
//                                                             <p className='text-[#858c97] text-[13px] font-semibold'>{formatTime(chat.ReceivedDate)}</p>
//                                                         </div>
//                                                     </div>
//                                                     :
//                                                     <div className='w-[100%]'>
//                                                         <div className="flex justify-center items-center my-3 w-[100%]">
//                                                             <span className="bg-gray-200 text-xs px-3 py-1 rounded-full font-bold text-[#434a57]">
//                                                                 service message sent
//                                                             </span>
//                                                         </div>
//                                                         <div className={`w-[100%] flex gap-2 justify-end flex`}>
//                                                             <div className=''>
//                                                                 <div className={`w-[100%] bg-[#448c74] p-4  text-[13px] font-semibold text-[#ffffff] rounded-t-[20px] rounded-l-[20px] rounded-br-none `}>
//                                                                     {chat.MessageText}
//                                                                 </div>
//                                                                 <p className={`text-[#858c97] text-[13px] w-[100%] font-semibold text-end`}>{formatTime(chat.ReceivedDate)}</p>
//                                                             </div>
//                                                             <div>
//                                                                 <img className='w-[50px] h-[50px]' src={SenderIcon} alt="" />
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 }
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )
//                             })
//                         ) : (
//                             <div className='text-center text-gray-400 p-10'>No chat history available.</div>
//                         )}
//                     </div>
//                 </div>
//                 <div className='w-[40%] p-6 bg-[#fff] min-h-screen'>
//                     <div className='w-[100%] rounded-lg'>
//                         <div className='w-[100%] flex gap-2 bg-gradient-to-br from-[#075E54] to-[#128C7E] p-6 rounded-t-[20px]'>
//                             <div className='w-[50px] h-[50px] bg-[#ada426] rounded-lg flex justify-center items-center text-[28px] uppercase font-semibold text-[#fff] '>
//                                 {(safeProfileName).slice(0, 2)}
//                             </div>
//                             <div>
//                                 <h1 className='text-[18px] text-[#fff] font-semibold '>{safeProfileName}</h1>
//                                 <h1 className='text-[18px] text-[#fff] font-semibold '>{safeWANumber}</h1>
//                             </div>
//                             <div className='text-[16px] text-[#fff] font-semibold flex items-center'>
//                                 <LuSquareArrowOutUpRight />
//                                 Export Chat
//                             </div>
//                         </div>
//                         <div className='bg-[#e5ddd536] w-[100%] p-4'>
//                             <div className='flex items-center justify-between w-[100%] '>
//                                 <span className='text-[#576071e0] text-[14px] font-semibold'>Last Message On</span>
//                                 <span className='text-[#576071e0] text-[14px] font-semibold'>{lastTime || 'N/A'}</span>
//                             </div>
//                             <div className='flex items-center justify-between w-[100%] mt-2 '>
//                                 <span className='text-[#576071e0] text-[14px] font-semibold'>Last Active</span>
//                                 <span className='text-[#576071e0] text-[14px] font-semibold'>{safeTimePassed}</span>
//                             </div>
//                             <div className='flex items-center justify-between w-[100%] mt-2 '>
//                                 <span className='text-[#576071e0] text-[14px] font-semibold'>Last Message</span>
//                                 <span className='text-[#576071e0] text-[14px] font-semibold'>{safeLastUserMessage}</span>
//                             </div>
//                             <div className='w-[100%] mt-8'>
//                                 <span className='text-[18px] text-[#448c74] flex font-semibold items-center gap-1'>Actions <FaArtstation /></span>
//                             </div>
//                             <div className='w-[100%] border-[#000] border-t-[1px]'>
//                                 <button className='flex items-center justify-center gap-2 w-[100%] p-3 text-[#fff] font-bold text-[14px] bg-[#ed5050] hover:bg-[#e92b2b] rounded-lg mt-3'>
//                                     <MdBlock />
//                                     Block {safeProfileName}
//                                 </button>
//                                 <div className='bg-[#f6f9fc] border-[#ddd] border-[1px] rounded-t-lg p-0 mt-2 '>
//                                     <div
//                                         onClick={() => setAssignAgent(!AssignAgent)}
//                                         className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer ${AssignAgent ? 'bg-[#edf1f5]' : ''} p-2 rounded-t-lg`} >
//                                         Assign Agent  {AssignAgent ? <IoIosArrowUp /> : <IoIosArrowDown />}
//                                     </div>
//                                     {AssignAgent &&
//                                         <div className='flex gap-1 mt-2 p-2'>
//                                             <button className='border-[1px] border-[#448c74] rounded-lg p-2 hover:bg-[#448c74] text-[#448c74] hover:text-[#FFF] text-[12px] font-semibold'>
//                                                 Gurpreet
//                                             </button>
//                                             <button className='border-[1px] border-[#448c74] rounded-lg p-2 hover:bg-[#448c74] text-[#448c74] hover:text-[#FFF] text-[12px] font-semibold'>
//                                                 Abiee
//                                             </button>
//                                             <button className='border-[1px] border-[#448c74] rounded-lg p-2 hover:bg-[#448c74] text-[#448c74] hover:text-[#FFF] text-[12px] font-semibold'>
//                                                 Pradeep
//                                             </button>
//                                         </div>
//                                     }
//                                 </div>
//                                 <div className='bg-[#f6f9fc] border-[#ddd] border-[1px] rounded-t-lg p-0 mt-2 '>
//                                     <div
//                                         onClick={() => setNotes(!Notes)}
//                                         className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer ${Notes ? 'bg-[#edf1f5]' : ''} p-2 rounded-t-lg`} >
//                                         Notes {Notes ? <IoIosArrowUp /> : <IoIosArrowDown />}
//                                     </div>
//                                     {Notes &&
//                                         <div className=' mt-2 p-2'>
//                                             <button
//                                                 onClick={() => setOpen(true)}
//                                                 className='border-[1px] border-[#448c74] rounded-lg p-2 bg-[#448c74] text-[#FFF] text-[12px] font-semibold'>
//                                                 <MdAdd />
//                                             </button>
//                                             {AddNotes.length > 0 ? (
//                                                 AddNotes.map((item) => (
//                                                     <div className='w-[100%] mt-2 ' key={item.id}>
//                                                         <div className='w-[100%] bg-[#fff9db] p-2 '>
//                                                             <div className='flex justify-between  gap-2'>
//                                                                 <div className='w-[35px] h-[35px] rounded-full border-[1px] border-[#eee] bg-[#eee] flex justify-center items-center'>
//                                                                     <FaUser />
//                                                                 </div>
//                                                                 <div>
//                                                                     <h1 className='text-[#576071] text-[12px] font-semibold'>{safeProfileName}</h1>
//                                                                     <h1 className='text-[#576071] text-[12px] font-semibold'>{item.time}</h1>
//                                                                 </div>
//                                                                 <div className='flex gap-1'>
//                                                                     <button
//                                                                         onClick={() => {
//                                                                             seteditId(item.id)
//                                                                             setOpen(true)
//                                                                             setNotestext(item.text)
//                                                                         }}
//                                                                         className='p-2 border-[1px] border-[#448c74] rounded-md text-[#448c74] hover:text-[#fff] hover:bg-[#448c74]'><FaEdit /></button>
//                                                                     <button
//                                                                         onClick={() => deleteNote(item.id)}
//                                                                         className='p-2 border-[1px] border-[#ed5050] rounded-md text-[#ed5050] hover:text-[#fff] hover:bg-[#ed5050]'><MdDelete /></button>
//                                                                 </div>
//                                                             </div>
//                                                             <p className='text-[14px] text-[#576071] font-semibold mt-3'>{item.text}</p>
//                                                         </div>
//                                                     </div>
//                                                 ))
//                                             ) : <p className='w-[100%] text-center text-[#858c97] text-[14px]'> No notes available</p>
//                                             }
//                                         </div>
//                                     }
//                                 </div>
//                                 <div className='bg-[#f6f9fc] border-[#ddd] border-[1px] rounded-t-lg p-0 mt-2 '>
//                                     <div
//                                         onClick={() => setCustomer(!Customer)}
//                                         className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer ${Customer ? 'bg-[#edf1f5]' : ''} p-2 rounded-t-lg`} >
//                                         Customer Journey  {Customer ? <IoIosArrowUp /> : <IoIosArrowDown />}
//                                     </div>
//                                     {Customer &&
//                                         <div className='flex pb-4 '>
//                                             <div className='flex gap-1 mt-2  relative px-4'>
//                                                 <div className='w-[10px] h-[10px] bg-[#000] rounded-full absolute left-3  '>
//                                                 </div>
//                                                 <div className='w-[1px] h-[30px] bg-[#000] '>
//                                                 </div>
//                                             </div>
//                                             <div className='mt-1' >
//                                                 <h5 className='text-[#576071] text-[12px] font-bold'>User Created</h5>
//                                                 <h5 className='text-[#576071] text-[10px] font-bold'>{FirstDate}{firstTime ? formatTime(firstTime) : ''}</h5>
//                                             </div>
//                                         </div>
//                                     }
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <AddNotesModal isOpen={open} onClose={() => setOpen(false)} heading={'Add Note'}>
//                 <textarea name="" id=""
//                     className='border-[1px] border-[#d4cfcf] w-[100%] rounded-lg outline-none mt-4 p-2'
//                     placeholder='Write your note...'
//                     rows={4}
//                     value={Notestext}
//                     onChange={(e) => setNotestext(e.target.value)}
//                 ></textarea>
//                 <div className='w-[100%] flex items-center justify-end mt-4 gap-2'>
//                     <button className='bg-[#edf1f5] hover:bg-[#d3dde6] text-[14px] font-semibold p-2 rounded-lg '
//                     >Cancel</button>
//                     <button
//                         onClick={() => {
//                             addNotes()
//                             setOpen(false)
//                         }}
//                         className='bg-[#3fca90] hover:bg-[#31b07b] text-[14px] text-[#fff] font-semibold p-2 rounded-lg '
//                     >Save</button>
//                 </div>
//             </AddNotesModal>
//         </>
//     )
// }

// export default WhatappchatforArchive
import React, { useState, useEffect } from 'react'
import chatBg from '../images/bg-pattern-liveAgent.png'
import SenderIcon from '../images/callericon.png'
import { LuSquareArrowOutUpRight } from "react-icons/lu";
import { FaArtstation } from "react-icons/fa";
import { MdBlock } from "react-icons/md";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdAdd } from "react-icons/md";
import { FaUser, FaEdit, FaCheck } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { FaUserPlus, FaUserMinus, FaSpinner } from "react-icons/fa6";
import AddNotesModal from './Addnotes';
import axios from 'axios';

// ─── Token helpers ────────────────────────────────────────────────────────────

function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64).split('').map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`).join('')
        );
        return JSON.parse(jsonPayload);
    } catch { return {}; }
}

function getAuthToken() {
    if (typeof window !== 'undefined') {
        if (typeof window.locatorgarsotrga === 'function') {
            const t = window.locatorgarsotrga("token");
            if (t) return t;
        }
        return localStorage.getItem('token') || null;
    }
    return null;
}

function getUserIdFromToken(token) {
    const decoded = decodeToken(token);
    return decoded.id || decoded.userId || decoded._id || null;
}



const API_URL = process.env.REACT_APP_API_BASE; // Change to your real API endpoint

 function getnameforuser(number) {
    if (!number) return undefined;

    const token = getAuthToken();
    const userId = getUserIdFromToken(token);
    if (!userId) return undefined;

    try {
        const res = axios.get(`${API_URL}/auth/contacts/${userId}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data && res.data.success && Array.isArray(res.data.contact)) {
            // Find contact with exact phone match (loose/strict depending on your store format)
            const contact = res.data.contact.find(
                c => (c.phone || c.number || '').replace(/\D/g, '').endsWith(number.replace(/\D/g, ''))
            );
            return contact ? contact.name : undefined;
        }
    } catch (error) {
        // Optionally handle error/log
        return undefined;
    }
    return undefined;
}

// ─── Profile helpers ──────────────────────────────────────────────────────────
// ✅ Replace the broken async function entirely
function getProfileName(user) {
    return user?.profileName || user?.ProfileName || user?.name || user?.from_number || "";
}
function getWANumber(user) {
    return user?.WANumber || user?.from_number || "";
}

// ─── Template message renderer ────────────────────────────────────────────────

function renderMessageContent(text, isOutgoing = false) {
    if (!text) return '';

    // Try to parse as WhatsApp template JSON
    try {
        const parsed = typeof text === 'string' ? JSON.parse(text) : text;

        if (parsed?.name && parsed?.language !== undefined) {
            const headerComp = parsed.components?.find(
                c => (c.type || '').toLowerCase() === 'header'
            );
            const bodyComp = parsed.components?.find(
                c => (c.type || '').toLowerCase() === 'body'
            );
            const footerComp = parsed.components?.find(
                c => (c.type || '').toLowerCase() === 'footer'
            );
            const buttonsComp = parsed.components?.find(
                c => (c.type || '').toLowerCase() === 'buttons'
            );

            // Substitute {{1}}, {{2}} … in body text with parameter values
            const params = bodyComp?.parameters || [];
            let bodyText = bodyComp?.text || '';
            params.forEach((param, i) => {
                bodyText = bodyText.replace(
                    new RegExp(`\\{\\{${i + 1}\\}\\}`, 'g'),
                    param.text || param.payload || ''
                );
            });

            const badgeBg    = isOutgoing ? 'bg-[#ffffff25]' : 'bg-[#448c7420]';
            const badgeText  = isOutgoing ? 'text-[#d4f1e8]'  : 'text-[#448c74]';
            const dividerClr = isOutgoing ? 'border-[#ffffff30]' : 'border-[#c8e6dc]';
            const btnClr     = isOutgoing ? 'text-[#d4f1e8]'  : 'text-[#448c74]';
            const footerClr  = isOutgoing ? 'text-[#ffffffa0]' : 'text-[#858c97]';

            return (
                <div className='flex flex-col gap-1 min-w-[160px]'>
                    {/* ── Template badge ── */}
                    <div className='flex items-center gap-1.5 mb-0.5'>
                        <span className={`text-[10px] ${badgeBg} ${badgeText} px-2 py-0.5 rounded-full font-bold uppercase tracking-wide`}>
                            Template
                        </span>
                        <span className={`text-[10px] ${footerClr} font-semibold truncate max-w-[140px]`}>
                            {parsed.name}
                        </span>
                    </div>

                    {/* ── Header ── */}
                    {headerComp?.text && (
                        <p className='font-bold text-[13px] leading-snug'>{headerComp.text}</p>
                    )}

                    {/* ── Body ── */}
                    {bodyText ? (
                        <p className='text-[13px] leading-snug whitespace-pre-wrap'>{bodyText}</p>
                    ) : params.length > 0 ? (
                        // fallback: show param values when no body text stored
                        <p className='text-[13px] leading-snug'>
                            {params.map(p => p.text || p.payload).filter(Boolean).join(' · ')}
                        </p>
                    ) : (
                        // last resort: just show template name in italics
                        <p className='text-[13px] italic opacity-75'>{parsed.name}</p>
                    )}

                    {/* ── Footer ── */}
                    {footerComp?.text && (
                        <p className={`text-[10px] ${footerClr} mt-0.5`}>{footerComp.text}</p>
                    )}

                    {/* ── Buttons ── */}
                    {buttonsComp?.buttons?.length > 0 && (
                        <div className={`mt-1 pt-1 border-t ${dividerClr} flex flex-col gap-0.5`}>
                            {buttonsComp.buttons.map((btn, i) => (
                                <span key={i} className={`text-[12px] ${btnClr} font-semibold text-center`}>
                                    {btn.text}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
            );
        }
    } catch {
        // Not JSON — fall through to plain text
    }

    // Plain text message
    return <span className='whitespace-pre-wrap'>{text}</span>;
}

// ─── Main Component ───────────────────────────────────────────────────────────

function WhatappchatforArchive({ selectedUser, currentPhoneNumberId }) {
    const token  = getAuthToken();
    const userId = getUserIdFromToken(token);

    // ── Normalise messages ────────────────────────────────────────────────────
    const chatsArray = Array.isArray(selectedUser?.Chats)
        ? selectedUser.Chats
        : (Array.isArray(selectedUser?.messages)
            ? selectedUser.messages.map(msg => ({
                ReceivedDate: msg.created_at,
                MessageText:  msg.content,
                ChatType:     msg.status === 'received' ? 'IN' : 'OUT',
                ...msg
            }))
            : []);

    const safeProfileName      = getProfileName(selectedUser);
    const safeWANumber         = getWANumber(selectedUser);
    const lastMessage          = chatsArray.length > 0 ? chatsArray[chatsArray.length - 1] : undefined;
    const lastTime             = lastMessage?.ReceivedDate || selectedUser?.lastTime || "";
    const firstMessage         = chatsArray.length > 0 ? chatsArray[0] : undefined;
    const firstTime            = firstMessage?.ReceivedDate;
    const FirstDate            = firstMessage?.TimePassed || "";
    const safeLastUserMessage  = selectedUser?.LastUserMessage || selectedUser?.lastMessage
        || lastMessage?.MessageText || lastMessage?.content || "";
    const safeTimePassed       = selectedUser?.TimePassed || "";

    // ── Panel toggles ─────────────────────────────────────────────────────────
    const [AssignAgent, setAssignAgent] = useState(false);
    const [Notes,       setNotes      ] = useState(false);
    const [Customer,    setCustomer   ] = useState(false);

    // ── Notes state ───────────────────────────────────────────────────────────
    const [Notestext, setNotestext] = useState('');
    const [AddNotes,  setAddNotes ] = useState([]);
    const [open,      setOpen     ] = useState(false);
    const [editId,    seteditId   ] = useState(null);

    // ── Agent assign state ────────────────────────────────────────────────────
    const [agents,            setAgents           ] = useState([]);
    const [agentsLoading,     setAgentsLoading    ] = useState(false);
    const [selectedAgentId,   setSelectedAgentId  ] = useState(null);
    const [currentAssignment, setCurrentAssignment] = useState(null);
    const [assigning,         setAssigning        ] = useState(false);
    const [assignError,       setAssignError      ] = useState('');

    const phoneNumberId  = currentPhoneNumberId || selectedUser?.phone_number_id || '';
    const customerNumber = safeWANumber;

    // ── Export Chat ───────────────────────────────────────────────────────────
    function exportChat() {
        if (!chatsArray.length) return;
        let chatStr = `Chat with ${safeProfileName} (${safeWANumber})\r\n\r\n`;
        let lastDateLabel = '';
        chatsArray.forEach(chat => {
            const thisDateLabel = formatDateLabel(chat.ReceivedDate);
            if (thisDateLabel !== lastDateLabel) {
                chatStr += `----- ${thisDateLabel} -----\r\n`;
                lastDateLabel = thisDateLabel;
            }
            // For export, strip JSON and use template name if template
            let exportText = chat.MessageText || '';
            try {
                const p = JSON.parse(exportText);
                if (p?.name) exportText = `[Template: ${p.name}]`;
            } catch {}
            if (chat.ChatType === 'IN') {
                chatStr += `[${formatTime(chat.ReceivedDate)}] ${safeProfileName}: ${exportText}\r\n`;
            } else {
                chatStr += `[${formatTime(chat.ReceivedDate)}] You: ${exportText}\r\n`;
            }
        });
        const blob = new Blob([chatStr], { type: "text/plain" });
        const url  = URL.createObjectURL(blob);
        const a    = document.createElement("a");
        a.href     = url;
        a.download = `chat_${safeProfileName || "user"}.txt`;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 0);
    }

    // ── Load agents ───────────────────────────────────────────────────────────
    useEffect(() => {
        if (!AssignAgent || !userId || !token) return;
        setAgentsLoading(true);
        setAssignError('');
        fetch(`https://wa-api.globebot.io/auth/agents/by-account?user_id=${userId}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(r => r.json())
            .then(data => {
                if (data.success) setAgents(data.data || []);
                else setAssignError('Could not load agents.');
            })
            .catch(() => setAssignError('Could not load agents.'))
            .finally(() => setAgentsLoading(false));
    }, [AssignAgent, userId, token]);

    // ── Load current assignment ───────────────────────────────────────────────
    useEffect(() => {
        if (!AssignAgent || !phoneNumberId || !customerNumber || !token) return;
        fetch(`https://wa-api.globebot.io/auth/chat-assignment?phone_number_id=${phoneNumberId}&customer_number=${customerNumber}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(r => r.json())
            .then(data => {
                if (data.success && data.data?.status === 'assigned') {
                    setCurrentAssignment(data.data);
                    setSelectedAgentId(data.data.agent_id);
                } else {
                    setCurrentAssignment(null);
                    setSelectedAgentId(null);
                }
            })
            .catch(console.error);
    }, [AssignAgent, phoneNumberId, customerNumber, token]);

    // ── Assign / Unassign ─────────────────────────────────────────────────────
    async function handleAssign() {
        if (!selectedAgentId || !phoneNumberId || !customerNumber) return;
        setAssigning(true);
        setAssignError('');
        try {
            const res  = await fetch('https://wa-api.globebot.io/auth/assign-chat', {
                method:  'POST',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body:    JSON.stringify({ phone_number_id: phoneNumberId, customer_number: customerNumber, agent_id: selectedAgentId, assigned_by: userId })
            });
            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.error || 'Assignment failed');
            const agent = agents.find(a => a.id === selectedAgentId);
            setCurrentAssignment({ agent_id: selectedAgentId, agent_name: agent?.name || data.agent_name || 'Agent', status: 'assigned', assigned_at: new Date().toISOString() });
        } catch (e) {
            setAssignError(e.message || 'Assignment failed');
        } finally {
            setAssigning(false);
        }
    }

    async function handleUnassign() {
        if (!phoneNumberId || !customerNumber) return;
        setAssigning(true);
        setAssignError('');
        try {
            const res  = await fetch('https://wa-api.globebot.io/auth/unassign-chat', {
                method:  'POST',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body:    JSON.stringify({ phone_number_id: phoneNumberId, customer_number: customerNumber })
            });
            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.error || 'Unassign failed');
            setCurrentAssignment(null);
            setSelectedAgentId(null);
        } catch (e) {
            setAssignError(e.message || 'Unassign failed');
        } finally {
            setAssigning(false);
        }
    }

    // ── Notes ─────────────────────────────────────────────────────────────────
    function getTime() {
        const now  = new Date();
        const pad  = n => String(n).padStart(2, '0');
        const h    = now.getHours() % 12 || 12;
        const ampm = now.getHours() >= 12 ? 'PM' : 'AM';
        return `${pad(now.getMonth()+1)}/${pad(now.getDate())}/${now.getFullYear()} ${pad(h)}:${pad(now.getMinutes())}${ampm}`;
    }

    function addNotes() {
        if (!Notestext.trim()) return;
        if (editId) {
            setAddNotes(prev => prev.map(item => item.id === editId ? { ...item, text: Notestext } : item));
            seteditId(null);
        } else {
            setAddNotes(prev => [...prev, { id: Date.now(), text: Notestext, time: getTime() }]);
        }
        setNotestext('');
        setOpen(false);
    }

    function deleteNote(id) { setAddNotes(prev => prev.filter(item => item.id !== id)); }

    // ── Formatting ────────────────────────────────────────────────────────────
    function formatDateLabel(date) {
        if (!date) return '';
        const d         = new Date(date);
        const today     = new Date();
        const yesterday = new Date(); yesterday.setDate(today.getDate() - 1);
        if (d.toDateString() === today.toDateString())     return "Today";
        if (d.toDateString() === yesterday.toDateString()) return "Yesterday";
        return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
    }
    const formatTime = date => date
        ? new Date(date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        : '';

    const isAssigned  = currentAssignment?.status === 'assigned' && currentAssignment?.agent_id;
    const stagedAgent = agents.find(a => a.id === selectedAgentId);
    const canSend     = selectedAgentId && selectedAgentId !== currentAssignment?.agent_id;

    // ── Render ────────────────────────────────────────────────────────────────
    return (
        <>
            <div className='w-full flex h-auto'>

                {/* ── Chat panel ───────────────────────────────────────────── */}
                <div style={{ backgroundImage: `url(${chatBg})` }} className='w-[60%] bg-cover bg-center h-[500px]'>

                    {/* Header */}
                    <div className='w-full border-[#e3e9ef] border-b py-2 px-4 flex gap-4 hidden'>
                        <div className='w-[60px] h-[60px] bg-[#0000000d] rounded-full flex justify-center items-center text-[28px] uppercase font-semibold text-[#576071]'>
                            {safeProfileName.slice(0, 2)}
                        </div>
                        <div>
                        <h3 className='text-[#000] text-[16px] font-bold capitalize'>
    {safeProfileName !== safeWANumber ? safeProfileName : safeWANumber}
</h3>
{safeProfileName !== safeWANumber && (
    <p className='text-[#858c97] text-[13px] font-semibold'>{safeWANumber}</p>
)}
                        </div>
                    </div>

                    {/* Messages */}
                    <div className='h-[480px] overflow-y-auto'>
                        {chatsArray.length > 0 ? chatsArray.map((chat, index) => {
                            const currentDate = new Date(chat.ReceivedDate).toDateString();
                            const prevDate    = index > 0 ? new Date(chatsArray[index - 1].ReceivedDate).toDateString() : null;
                            const isOutgoing  = chat.ChatType !== 'IN';

                            return (
                                <div className='w-full px-2' key={chat?.id || chat?.ReceivedDate || index}>

                                    {/* Date separator */}
                                    {currentDate !== prevDate && (
                                        <div className="text-center my-3">
                                            <span className="bg-gray-200 text-xs px-3 py-1 rounded-full font-bold text-[#434a57]">
                                                {formatDateLabel(chat.ReceivedDate)}
                                            </span>
                                        </div>
                                    )}

                                    {/* ── Incoming ── */}
                                    {!isOutgoing ? (
                                        <div className="flex gap-2 justify-start mb-2">
                                            <div className='w-[48px] h-[48px] bg-[#3f7fca26] rounded-full flex justify-center items-center text-[20px] uppercase font-semibold text-[#3f7fca] flex-shrink-0'>
                                                {safeProfileName.slice(0, 2)}
                                            </div>
                                            <div className='max-w-[75%]'>
                                                <div className='bg-[#3f80ca15] p-4 text-[13px] font-semibold text-[#121519d1] rounded-t-[20px] rounded-r-[20px] rounded-bl-none'>
                                                    {renderMessageContent(chat.MessageText, false)}
                                                </div>
                                                <p className='text-[#858c97] text-[12px] font-semibold mt-0.5'>
                                                    {formatTime(chat.ReceivedDate)}
                                                </p>
                                            </div>
                                        </div>

                                    ) : (
                                        /* ── Outgoing ── */
                                        <div className='w-full mb-2'>
                                            <div className="flex justify-center items-center my-2">
                                                <span className="bg-gray-200 text-xs px-3 py-1 rounded-full font-bold text-[#434a57]">
                                                    service message sent
                                                </span>
                                            </div>
                                            <div className="w-full flex gap-2 justify-end">
                                                <div className='max-w-[75%]'>
                                                    <div className='bg-[#448c74] p-4 text-[13px] font-semibold text-white rounded-t-[20px] rounded-l-[20px] rounded-br-none'>
                                                        {renderMessageContent(chat.MessageText, true)}
                                                    </div>
                                                    <p className='text-[#858c97] text-[12px] font-semibold text-end mt-0.5'>
                                                        {formatTime(chat.ReceivedDate)}
                                                    </p>
                                                </div>
                                                <img className='w-[50px] h-[50px] flex-shrink-0' src={SenderIcon} alt="" />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        }) : (
                            <div className='text-center text-gray-400 p-10'>No chat history available.</div>
                        )}
                    </div>
                </div>

                {/* ── Right panel ──────────────────────────────────────────── */}
                <div className='w-[40%] p-6 bg-white min-h-screen overflow-y-auto'>
                    <div className='w-full rounded-lg'>

                        {/* Profile header */}
                        <div className='w-full flex gap-2 bg-gradient-to-br from-[#075E54] to-[#128C7E] p-6 rounded-t-[20px]'>
                            <div className='w-[50px] h-[50px] bg-[#ada426] rounded-lg flex justify-center items-center text-[28px] uppercase font-semibold text-white'>
                            {(safeProfileName !== safeWANumber ? safeProfileName : safeWANumber).slice(0, 2).toUpperCase()}

                            </div>
                            <div className='flex-1 min-w-0'>
                            <h1 className='text-[18px] text-white font-semibold truncate'>
    {safeProfileName !== safeWANumber ? safeProfileName : safeWANumber}
</h1>
{safeProfileName !== safeWANumber && (
    <p className='text-[13px] text-white opacity-80'>{safeWANumber}</p>
)}
                            </div>
                            <div
                                className='text-[13px] text-white font-semibold flex items-center gap-1 cursor-pointer hover:opacity-80 select-none'
                                title="Export chat as .txt"
                                tabIndex={0}
                                style={{ outline: "none" }}
                                onClick={exportChat}
                                onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') exportChat(); }}
                            >
                                <LuSquareArrowOutUpRight /> Export Chat
                            </div>
                        </div>

                        {/* Meta info */}
                        <div className='bg-[#e5ddd536] w-full p-4'>
                            <div className='flex items-center justify-between w-full'>
                                <span className='text-[#576071e0] text-[14px] font-semibold'>Last Message On</span>
                                <span className='text-[#576071e0] text-[14px] font-semibold'>{lastTime || 'N/A'}</span>
                            </div>
                            <div className='flex items-center justify-between w-full mt-2'>
                                <span className='text-[#576071e0] text-[14px] font-semibold'>Last Active</span>
                                <span className='text-[#576071e0] text-[14px] font-semibold'>{safeTimePassed}</span>
                            </div>
                            <div className='flex items-center justify-between w-full mt-2'>
                                <span className='text-[#576071e0] text-[14px] font-semibold'>Last Message</span>
                                <span className='text-[#576071e0] text-[14px] font-semibold truncate max-w-[150px]'>{safeLastUserMessage}</span>
                            </div>

                            <div className='w-full mt-8'>
                                <span className='text-[18px] text-[#448c74] flex font-semibold items-center gap-1'>
                                    Actions <FaArtstation />
                                </span>
                            </div>

                            <div className='w-full border-t border-black'>

                                {/* Block */}
                                <button className='flex items-center justify-center gap-2 w-full p-3 text-white font-bold text-[14px] bg-[#ed5050] hover:bg-[#e92b2b] rounded-lg mt-3'>
                                    <MdBlock /> Block {safeProfileName}
                                </button>

                                {/* ── ASSIGN AGENT ──────────────────────────── */}
                                <div className='bg-[#f6f9fc] border border-[#ddd] rounded-t-lg mt-2'>
                                    <div
                                        onClick={() => setAssignAgent(!AssignAgent)}
                                        className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer p-2 rounded-t-lg select-none ${AssignAgent ? 'bg-[#edf1f5]' : ''}`}
                                    >
                                        <span className='flex items-center gap-2'>
                                            <FaUserPlus className='text-[#448c74]' />
                                            Assign Agent
                                            {isAssigned && (
                                                <span className='inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#e8f8f2] text-[#37715d] text-[11px] font-bold border border-[#c3edd9]'>
                                                    <span className='w-1.5 h-1.5 rounded-full bg-[#16D39A]' />
                                                    {currentAssignment.agent_name}
                                                </span>
                                            )}
                                        </span>
                                        {AssignAgent ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                    </div>

                                    {AssignAgent && (
                                        <div className='p-3'>
                                            {agentsLoading && (
                                                <div className='flex items-center gap-2 text-[#448c74] text-[13px] py-2'>
                                                    <FaSpinner className='animate-spin' /> Loading agents…
                                                </div>
                                            )}
                                            {assignError && <p className='text-red-400 text-[12px] mb-2'>{assignError}</p>}
                                            {!agentsLoading && (
                                                <div className='flex flex-wrap gap-2'>
                                                    {agents.length === 0 && (
                                                        <p className='text-[#858c97] text-[12px]'>No agents available.</p>
                                                    )}
                                                    {agents.map(agent => {
                                                        const isActive         = selectedAgentId === agent.id;
                                                        const isAssignedToThis = currentAssignment?.agent_id === agent.id && isAssigned;
                                                        return (
                                                            <button
                                                                key={agent.id}
                                                                onClick={() => setSelectedAgentId(isActive ? null : agent.id)}
                                                                disabled={assigning}
                                                                className={`flex items-center gap-1.5 border rounded-lg px-3 py-1.5 text-[12px] font-semibold transition-all duration-150
                                                                    ${isAssignedToThis
                                                                        ? 'bg-[#448c74] text-white border-[#448c74]'
                                                                        : isActive
                                                                            ? 'bg-[#16D39A] text-white border-[#16D39A] shadow-md scale-105'
                                                                            : 'border-[#448c74] text-[#448c74] hover:bg-[#448c74] hover:text-white'
                                                                    } disabled:opacity-60`}
                                                            >
                                                                {isAssignedToThis && <FaCheck className='text-[10px]' />}
                                                                <span>{agent.name}</span>
                                                                {isAssignedToThis && <span className='text-[10px] opacity-80'>(assigned)</span>}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                            {canSend && (
                                                <div className='mt-3 flex items-center gap-2'>
                                                    <button
                                                        onClick={handleAssign}
                                                        disabled={assigning}
                                                        className='flex items-center gap-2 px-4 py-2 bg-[#448c74] hover:bg-[#37715d] text-white text-[13px] font-bold rounded-lg transition-all duration-150 disabled:opacity-60'
                                                    >
                                                        {assigning ? <><FaSpinner className='animate-spin' /> Assigning…</> : <><FaUserPlus /> Assign to {stagedAgent?.name}</>}
                                                    </button>
                                                    <button
                                                        onClick={() => setSelectedAgentId(currentAssignment?.agent_id || null)}
                                                        disabled={assigning}
                                                        className='px-3 py-2 text-[12px] font-semibold text-[#576071] bg-[#edf1f5] hover:bg-[#d3dde6] rounded-lg transition-all duration-150'
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            )}
                                            {isAssigned && !canSend && (
                                                <div className='mt-3'>
                                                    <button
                                                        onClick={handleUnassign}
                                                        disabled={assigning}
                                                        className='flex items-center gap-2 px-4 py-2 bg-white border border-[#ed5050] text-[#ed5050] hover:bg-[#ed5050] hover:text-white text-[12px] font-bold rounded-lg transition-all duration-150 disabled:opacity-60'
                                                    >
                                                        {assigning ? <><FaSpinner className='animate-spin' /> Unassigning…</> : <><FaUserMinus /> Unassign {currentAssignment.agent_name}</>}
                                                    </button>
                                                </div>
                                            )}
                                            {isAssigned && !canSend && !assigning && (
                                                <p className='mt-2 text-[12px] text-[#448c74] font-semibold flex items-center gap-1'>
                                                    <FaCheck /> Chat assigned to {currentAssignment.agent_name}
                                                </p>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* ── NOTES ─────────────────────────────────── */}
                                <div className='bg-[#f6f9fc] border border-[#ddd] rounded-t-lg mt-2'>
                                    <div
                                        onClick={() => setNotes(!Notes)}
                                        className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer p-2 rounded-t-lg ${Notes ? 'bg-[#edf1f5]' : ''}`}
                                    >
                                        Notes {Notes ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                    </div>
                                    {Notes && (
                                        <div className='mt-2 p-2'>
                                            <button onClick={() => setOpen(true)} className='border border-[#448c74] rounded-lg p-2 bg-[#448c74] text-white text-[12px] font-semibold'>
                                                <MdAdd />
                                            </button>
                                            {AddNotes.length > 0 ? AddNotes.map(item => (
                                                <div className='w-full mt-2' key={item.id}>
                                                    <div className='w-full bg-[#fff9db] p-2'>
                                                        <div className='flex justify-between gap-2'>
                                                            <div className='w-[35px] h-[35px] rounded-full border border-[#eee] bg-[#eee] flex justify-center items-center'>
                                                                <FaUser />
                                                            </div>
                                                            <div>
                                                                <h1 className='text-[#576071] text-[12px] font-semibold'>{safeProfileName}</h1>
                                                                <h1 className='text-[#576071] text-[12px] font-semibold'>{item.time}</h1>
                                                            </div>
                                                            <div className='flex gap-1'>
                                                                <button
                                                                    onClick={() => { seteditId(item.id); setOpen(true); setNotestext(item.text); }}
                                                                    className='p-2 border border-[#448c74] rounded-md text-[#448c74] hover:text-white hover:bg-[#448c74]'>
                                                                    <FaEdit />
                                                                </button>
                                                                <button
                                                                    onClick={() => deleteNote(item.id)}
                                                                    className='p-2 border border-[#ed5050] rounded-md text-[#ed5050] hover:text-white hover:bg-[#ed5050]'>
                                                                    <MdDelete />
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <p className='text-[14px] text-[#576071] font-semibold mt-3'>{item.text}</p>
                                                    </div>
                                                </div>
                                            )) : <p className='w-full text-center text-[#858c97] text-[14px]'>No notes available</p>}
                                        </div>
                                    )}
                                </div>

                                {/* ── CUSTOMER JOURNEY ──────────────────────── */}
                                <div className='bg-[#f6f9fc] border border-[#ddd] rounded-t-lg mt-2'>
                                    <div
                                        onClick={() => setCustomer(!Customer)}
                                        className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer p-2 rounded-t-lg ${Customer ? 'bg-[#edf1f5]' : ''}`}
                                    >
                                        Customer Journey {Customer ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                    </div>
                                    {Customer && (
                                        <div className='flex pb-4'>
                                            <div className='flex gap-1 mt-2 relative px-4'>
                                                <div className='w-[10px] h-[10px] bg-black rounded-full absolute left-3' />
                                                <div className='w-[1px] h-[30px] bg-black' />
                                            </div>
                                            <div className='mt-1'>
                                                <h5 className='text-[#576071] text-[12px] font-bold'>User Created</h5>
                                                <h5 className='text-[#576071] text-[10px] font-bold'>{FirstDate}{firstTime ? formatTime(firstTime) : ''}</h5>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Notes Modal */}
            <AddNotesModal isOpen={open} onClose={() => setOpen(false)} heading={'Add Note'}>
                <textarea
                    className='border border-[#d4cfcf] w-full rounded-lg outline-none mt-4 p-2'
                    placeholder='Write your note...'
                    rows={4}
                    value={Notestext}
                    onChange={e => setNotestext(e.target.value)}
                />
                <div className='w-full flex items-center justify-end mt-4 gap-2'>
                    <button
                        onClick={() => setOpen(false)}
                        className='bg-[#edf1f5] hover:bg-[#d3dde6] text-[14px] font-semibold p-2 rounded-lg'
                    >Cancel</button>
                    <button
                        onClick={() => { addNotes(); setOpen(false); }}
                        className='bg-[#3fca90] hover:bg-[#31b07b] text-white text-[14px] font-semibold p-2 rounded-lg'
                    >Save</button>
                </div>
            </AddNotesModal>
        </>
    );
}

export default WhatappchatforArchive;